// Common description constants to avoid duplication
const COMMON_DESCRIPTIONS = {
  // Bank Account
  ADD_BANK_ACCOUNT: 'Add bank account',
  UPDATE_BANK_ACCOUNT: 'Update bank account details',
  USE_DIFFERENT_BANK_ACCOUNT: 'Use different bank account',
  
  // Bank Account Details - "Add bankAccount.X to bank account" pattern
  ADD_BANK_ACCOUNT_IBAN: 'Add bankAccount.iban to bank account',
  ADD_BANK_ACCOUNT_NUMBER: 'Add bankAccount.accountNumber to bank account', 
  ADD_BANK_ACCOUNT_BRANCH_CODE: 'Add bankAccount.branchCode to bank account',
  ADD_BANK_ACCOUNT_SORT_CODE: 'Add bankAccount.sortCode to bank account',
  ADD_BANK_ACCOUNT_TYPE: 'Add bankAccount.accountType to bank account',
  ADD_BANK_ACCOUNT_BIC_SWIFT: 'Add bankAccount.bankBicSwift to bank account',
  ADD_BANK_ACCOUNT_CITY: 'Add bankAccount.bankCity to bank account',
  ADD_BANK_ACCOUNT_CODE: 'Add bankAccount.bankCode to bank account',
  ADD_BANK_ACCOUNT_NAME: 'Add bankAccount.bankName to bank account',
  ADD_BANK_ACCOUNT_CHECK_CODE: 'Add bankAccount.checkCode to bank account',
  ADD_BANK_ACCOUNT_COUNTRY: 'Add bankAccount.bankCountry to bank account',
  ADD_BANK_ACCOUNT_CURRENCY: 'Add bankAccount.currencyCode to bank account',
  
  // Legal Entity - Individual
  ADD_INDIVIDUAL_NAME: 'Add individual.name to legal entity',
  ADD_INDIVIDUAL_BIRTH_DATA: 'Add individual.birthData to legal entity',
  ADD_INDIVIDUAL_RESIDENTIAL_ADDRESS: 'Add individual.residentialAddress to legal entity',
  ADD_INDIVIDUAL_IDENTIFICATION_DATA: 'Add individual.identificationData to legal entity',
  
  // Individual Details - "Add individual.X to legal entity" pattern
  ADD_INDIVIDUAL_FIRST_NAME: 'Add individual.name.firstName to legal entity',
  ADD_INDIVIDUAL_LAST_NAME: 'Add individual.name.lastName to legal entity',
  ADD_INDIVIDUAL_COUNTRY: 'Add individual.residentialAddress.country to legal entity',
  ADD_INDIVIDUAL_STATE: 'Add individual.residentialAddress.stateOrProvince to legal entity',
  ADD_INDIVIDUAL_STREET: 'Add individual.residentialAddress.street to legal entity',
  ADD_INDIVIDUAL_CITY: 'Add individual.residentialAddress.city to legal entity',
  ADD_INDIVIDUAL_POSTAL_CODE: 'Add individual.residentialAddress.postalcode to legal entity',
  ADD_INDIVIDUAL_STREET2: 'Add individual.residentialAddress.street2 to legal entity',
  ADD_INDIVIDUAL_NATIONALITY: 'Add individual.nationality to legal entity',
  ADD_INDIVIDUAL_DATE_OF_BIRTH: 'Add individual.birthData.dateOfBirth to legal entity',
  ADD_INDIVIDUAL_IDENTIFICATION_NUMBER: 'Add individual.identificationData.number to legal entity',
  ADD_INDIVIDUAL_IDENTIFICATION_TYPE: 'Add individual.identificationData.type to legal entity',
  ADD_INDIVIDUAL_EMAIL: 'Add individual.email to legal entity',
  
  // Phone Details - "Add phone.X to legal entity" pattern
  ADD_PHONE_NUMBER: 'Add phone.number to legal entity',
  ADD_PHONE_TYPE: 'Add phone.type to legal entity', 
  ADD_PHONE_COUNTRY_CODE: 'Add phone.countryCode to legal entity',
  
  // Tax and Entity Association Details
  ADD_ENTITY_ASSOCIATION_JOB_TITLE: 'Add entityAssociation.jobTitle to legal entity',
  ADD_TAX_INFORMATION: 'Add tax information to legal entity',
  ADD_TAX_INFORMATION_NUMBER: 'Add taxInformation.number to legal entity',
  ADD_TAX_INFORMATION_TYPE: 'Add taxInformation.type to legal entity',
  ADD_TAX_INFORMATION_COUNTRY: 'Add taxInformation.country to legal entity',
  ADD_PROOF_OF_INDIVIDUAL_TAX_ID: 'Add proofOfIndividualTaxId to legal entity',
  ADD_VAT_DOCUMENT_TO_ENTITY: 'Add vatDocument to legal entity',
  ADD_TAX_REPORTING_CLASSIFICATION: 'Add taxReportingClassification to legal entity',
  ADD_TAX_REPORTING_CLASSIFICATION_TYPE: 'Add taxReportingClassification.type to legal entity',
  ADD_TAX_REPORTING_CLASSIFICATION_BUSINESS_TYPE: 'Add taxReportingClassification.businessType to legal entity',
  ADD_TAX_REPORTING_CLASSIFICATION_MAIN_SOURCE: 'Add taxReportingClassification.mainSourceOfIncome to legal entity',
  ADD_TAX_REPORTING_CLASSIFICATION_FIN_INST_NUMBER: 'Add taxReportingClassification.financialInstitutionNumber to legal entity',
  
  // Legal Entity - Organization
  ADD_ORGANIZATION_REGISTRATION_NUMBER: 'Add organization.registrationNumber to legal entity',
  ADD_ORGANIZATION_TAX_ID: 'Add organization.taxId to legal entity',
  ADD_ORGANIZATION_LEGAL_NAME: 'Add organization.legalName to legal entity',
  ADD_ORGANIZATION_TYPE: 'Add organization.type to legal entity',
  
  // Organization Details - "Add organization.X to legal entity" pattern
  ADD_ORGANIZATION_UBO_THROUGH_OWNERSHIP: 'Add organization.entityAssociations of type uboThroughOwnership to legal entity',
  ADD_ORGANIZATION_SIGNATORY: 'Add organization.entityAssociations of type signatory to legal entity',
  ADD_ORGANIZATION_DOING_BUSINESS_AS: 'Add organization.doingBusinessAs to legal entity',
  ADD_ORGANIZATION_MARKET_IDENTIFIER: 'Add organization.stockData.marketIdentifier to legal entity',
  ADD_ORGANIZATION_STOCK_NUMBER: 'Add organization.stockData.stockNumber to legal entity',
  ADD_ORGANIZATION_TICKER_SYMBOL: 'Add organization.stockData.tickerSymbol to legal entity',
  ADD_ORGANIZATION_UBO_THROUGH_CONTROL: 'Add organization.entityAssociations of type uboThroughControl to legal entity',
  ADD_ORGANIZATION_VAT_NUMBER: 'Add organization.vatNumber to legal entity',
  ADD_SOLE_PROPRIETORSHIP_REGISTRATION_NUMBER: 'Add soleProprietorship.registrationNumber to legal entity',
  
  // Business Profile - "Add X to business line" pattern
  ADD_BUSINESS_LINE: 'Add business line',
  ADD_SOURCE_OF_FUNDS: 'Add source of funds to business line',
  ADD_SOURCE_OF_FUNDS_TYPE: 'Add businessLine.sourceOfFunds.type to business line',
  ADD_ADYEN_PROCESSED_FUNDS: 'Add businessLine.sourceOfFunds.adyenProcessedFunds to business line',
  ADD_SOURCE_OF_FUNDS_DESCRIPTION: 'Add businessLine.sourceOfFunds.description to business line',
  ADD_INDUSTRY_CODE: 'Add industryCode to business line',
  ADD_CHANNEL: 'Add channel to business line',
  ADD_WEB_ADDRESS_TO_BUSINESS_LINE: 'Add webAddress to business line',
  ADD_WEB_DATA_ADDRESS: 'Add webData.webAddress to business line',
  
  // Update Messages
  UPDATE_INDUSTRY: 'Update industry',
  UPDATE_WEB_ADDRESS: 'Update the web address with a website or application that represents your business',
  UPDATE_INDIVIDUAL_DETAILS: 'Update individual details',
  UPDATE_NAME_KATAKANA: 'Update the name (Katakana) with only full-width Katakana characters and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_NAME_KANJI: 'Update the name (Kanji) with only full-width Katakana, Kanji or Latin characters, and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_RESIDENCY_STREET: 'Update the residency street in full-width Kanji and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_NATIONAL_ID: 'Update the national Id number to a 9 digit SSN',
  UPDATE_ORGANIZATION_DETAILS: 'Update tax details',
  UPDATE_ORGANIZATION_OWNERSHIP: 'Update organization ownership details',
  UPDATE_ORGANIZATION_NAME_KATAKANA: 'Update the organization name (Katakana) with only full-width Katakana characters and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_ORGANIZATION_NAME_KANJI: 'Update the organization name (Kanji) with only full-width Katakana, Kanji or Latin characters, and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_REGISTERED_STREET: 'Update the registered street in full-width Kanji and remove any invalid characters such as spaces, restricted or special characters',
  UPDATE_LEGAL_ARRANGEMENT: 'Update legal arrangement details',
  
  // Document Upload
  UPLOAD_DOCUMENT: 'Upload a document',
  UPLOAD_DIFFERENT_DOCUMENT: 'Upload a different document',
  UPLOAD_VAT_DOCUMENT: 'Upload a VAT document',
  UPLOAD_DIFFERENT_VAT_DOCUMENT: 'Upload a different VAT document',
  UPLOAD_CONSTITUTIONAL_DOCUMENT: 'Upload a constitutional document',
  UPLOAD_DIFFERENT_CONSTITUTIONAL_DOCUMENT: 'Upload a different constitutional document',
  UPLOAD_BANK_STATEMENT: 'Upload a bank statement',
  UPLOAD_DIFFERENT_BANK_STATEMENT: 'Upload a different bank statement',
  UPLOAD_PROOF_OF_INDUSTRY: 'Upload a proof of industry',
  UPLOAD_DIFFERENT_PROOF_OF_INDUSTRY: 'Upload a different proof of industry',
  UPLOAD_ID_DOCUMENT: 'Upload an ID document',
  UPLOAD_DIFFERENT_ID_DOCUMENT: 'Upload a different ID document',
  UPLOAD_DIFFERENT_ID_IMAGE: 'Upload a different image of the ID document',
  UPLOAD_PROOF_OF_RESIDENCY: 'Upload proof of residency',
  UPLOAD_DIFFERENT_PROOF_OF_RESIDENCY: 'Upload a different proof of residency',
  UPLOAD_DIFFERENT_RESIDENCY_IMAGE: 'Upload a different image of the proof of residency',
  UPLOAD_REGISTRATION_DOCUMENT: 'Upload a registration document',
  UPLOAD_DIFFERENT_REGISTRATION_DOCUMENT: 'Upload a different registration document',
  UPLOAD_PROOF_OF_NATIONAL_ID: 'Upload a proof of national ID number',
  UPLOAD_DIFFERENT_PROOF_OF_NATIONAL_ID: 'Upload a different proof of national ID number',
  UPLOAD_DIFFERENT_NATIONAL_ID_IMAGE: 'Upload a different image of the proof of national ID number',
  UPLOAD_PROOF_OF_INDIVIDUAL_TAX_ID: 'Upload a proof of the individual tax ID',
  UPLOAD_DIFFERENT_PROOF_OF_INDIVIDUAL_TAX_ID: 'Upload a different proof of the individual tax ID',
  UPLOAD_DIFFERENT_INDIVIDUAL_TAX_ID_IMAGE: 'Upload a different image of the proof of the individual tax ID',
  UPLOAD_PROOF_OF_ADDRESS: 'Upload a proof of address',
  UPLOAD_DIFFERENT_PROOF_OF_ADDRESS: 'Upload a different proof of address',
  UPLOAD_DIFFERENT_INDUSTRY_IMAGE: 'Upload a different image of the proof of industry',
  UPLOAD_PROOF_OF_OWNERSHIP: 'Upload a proof of ownership document',
  UPLOAD_ATTACHMENT_DOCUMENT: 'Upload the required document',
};

export const fieldErrorMapping = {
  ADYEN: {
    BANK_ACCOUNT : {
      "1_700" : {
        field: 'accountNumber',
        description: COMMON_DESCRIPTIONS.UPDATE_BANK_ACCOUNT
      },
      "1_701" : {
        field: 'accountNumber',
        description: COMMON_DESCRIPTIONS.USE_DIFFERENT_BANK_ACCOUNT
      },
      "2_113" : {
        field: 'iban',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_IBAN
      },
      "2_114" : {
        field: 'accountNumber',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_NUMBER
      },
      "2_115" : {
        field: 'bankAccount',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT
      },
      "2_116" : {
        field: 'branchCode',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_BRANCH_CODE
      },
      "2_135" : {
        field: 'sortCode',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_SORT_CODE
      },
      "2_140" : {
        field: 'accountType',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_TYPE
      },
      "2_141" : {
        field: 'bankBicSwift',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_BIC_SWIFT
      },
      "2_142" : {
        field: 'bankCity',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_CITY
      },
      "2_143" : {
        field: 'bankCode',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_CODE
      },
      "2_144" : {
        field: 'bankName',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_NAME
      },
      "2_145" : {
        field: 'checkCode',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_CHECK_CODE
      },
      "2_146" : {
        field: 'bankCountry',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_COUNTRY
      },
      "2_147" : {
        field: 'currencyCode',
        description: COMMON_DESCRIPTIONS.ADD_BANK_ACCOUNT_CURRENCY
      },
    },
    BUSINESS_REGISTRATION : {
      "1_500" : {
        field: 'organisationTaxId',
        description: COMMON_DESCRIPTIONS.UPDATE_ORGANIZATION_DETAILS
      },
      "1_507" : {
        field: 'organizationOwnership',
        description: COMMON_DESCRIPTIONS.UPDATE_ORGANIZATION_OWNERSHIP
      },
      "1_514" : {
        field: 'organizationName',
        description: COMMON_DESCRIPTIONS.UPDATE_ORGANIZATION_NAME_KATAKANA
      },
      "1_515" : {
        field: 'organizationName',
        description: COMMON_DESCRIPTIONS.UPDATE_ORGANIZATION_NAME_KANJI
      },
      "1_516" : {
        field: 'registeredStreet',
        description: COMMON_DESCRIPTIONS.UPDATE_REGISTERED_STREET
      },
      "1_600" : {
        field: 'legalArrangement',
        description: COMMON_DESCRIPTIONS.UPDATE_LEGAL_ARRANGEMENT
      },
      "2_117" : {
        field: 'registrationNumber',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_REGISTRATION_NUMBER
      },
      "2_118" : {
        field: 'taxId',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_TAX_ID
      },
      "2_123" : {
        field: 'uboThroughOwnership',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_UBO_THROUGH_OWNERSHIP
      },
      "2_124" : {
        field: 'signatory',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_SIGNATORY
      },
      "2_125" : {
        field: 'organizationType',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_TYPE
      },
      "2_132" : {
        field: 'legalName',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_LEGAL_NAME
      },
      "2_133" : {
        field: 'doingBusinessAs',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_DOING_BUSINESS_AS
      },
      "2_148" : {
        field: 'marketIdentifier',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_MARKET_IDENTIFIER
      },
      "2_149" : {
        field: 'stockNumber',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_STOCK_NUMBER
      },
      "2_150" : {
        field: 'tickerSymbol',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_TICKER_SYMBOL
      },
      "2_151" : {
        field: 'uboThroughControl',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_UBO_THROUGH_CONTROL
      },
      "2_158" : {
        field: 'vatNumber',
        description: COMMON_DESCRIPTIONS.ADD_ORGANIZATION_VAT_NUMBER
      },
      "2_189" : {
        field: 'registrationNumber',
        description: COMMON_DESCRIPTIONS.ADD_SOLE_PROPRIETORSHIP_REGISTRATION_NUMBER
      },
    },
    CONTROL_PERSON : {
      "1_300" : {
        field: 'individualDetails',
        description: COMMON_DESCRIPTIONS.UPDATE_INDIVIDUAL_DETAILS
      },
      "1_310" : {
        field: 'nameKatakana',
        description: COMMON_DESCRIPTIONS.UPDATE_NAME_KATAKANA
      },
      "1_311" : {
        field: 'nameKanji',
        description: COMMON_DESCRIPTIONS.UPDATE_NAME_KANJI
      },
      "1_312" : {
        field: 'residencyStreet',
        description: COMMON_DESCRIPTIONS.UPDATE_RESIDENCY_STREET
      },
      "1_316" : {
        field: 'nationalId',
        description: COMMON_DESCRIPTIONS.UPDATE_NATIONAL_ID
      },
      "2_101" : {
        field: 'identificationData',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_IDENTIFICATION_DATA
      },
      "2_102" : {
        field: 'firstName',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_FIRST_NAME
      },
      "2_103" : {
        field: 'lastName',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_LAST_NAME
      },
      "2_104" : {
        field: 'country',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_COUNTRY
      },
      "2_105" : {
        field: 'stateOrProvince',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_STATE
      },
      "2_106" : {
        field: 'street',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_STREET
      },
      "2_107" : {
        field: 'city',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_CITY
      },
      "2_108" : {
        field: 'postalCode',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_POSTAL_CODE
      },
      "2_109" : {
        field: 'street2',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_STREET2
      },
      "2_110" : {
        field: 'nationality',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_NATIONALITY
      },
      "2_112" : {
        field: 'dateOfBirth',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_DATE_OF_BIRTH
      },
      "2_120" : {
        field: 'name',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_NAME
      },
      "2_121" : {
        field: 'birthData',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_BIRTH_DATA
      },
      "2_122" : {
        field: 'residentialAddress',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_RESIDENTIAL_ADDRESS
      },
      "2_138" : {
        field: 'identificationNumber',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_IDENTIFICATION_NUMBER
      },
      "2_139" : {
        field: 'identificationType',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_IDENTIFICATION_TYPE
      },
      "2_152" : {
        field: 'email',
        description: COMMON_DESCRIPTIONS.ADD_INDIVIDUAL_EMAIL
      },
      "2_153" : {
        field: 'phoneNumber',
        description: COMMON_DESCRIPTIONS.ADD_PHONE_NUMBER
      },
      "2_154" : {
        field: 'phoneType',
        description: COMMON_DESCRIPTIONS.ADD_PHONE_TYPE
      },
      "2_155" : {
        field: 'phoneCountryCode',
        description: COMMON_DESCRIPTIONS.ADD_PHONE_COUNTRY_CODE
      },
      "2_156" : {
        field: 'jobTitle',
        description: COMMON_DESCRIPTIONS.ADD_ENTITY_ASSOCIATION_JOB_TITLE
      },
      "2_170" : {
        field: 'taxInformation',
        description: COMMON_DESCRIPTIONS.ADD_TAX_INFORMATION
      },
      "2_171" : {
        field: 'taxNumber',
        description: COMMON_DESCRIPTIONS.ADD_TAX_INFORMATION_NUMBER
      },
      "2_172" : {
        field: 'taxType',
        description: COMMON_DESCRIPTIONS.ADD_TAX_INFORMATION_TYPE
      },
      "2_173" : {
        field: 'taxCountry',
        description: COMMON_DESCRIPTIONS.ADD_TAX_INFORMATION_COUNTRY
      },
      "2_174" : {
        field: 'proofOfIndividualTaxId',
        description: COMMON_DESCRIPTIONS.ADD_PROOF_OF_INDIVIDUAL_TAX_ID
      },
      "2_175" : {
        field: 'vatDocument',
        description: COMMON_DESCRIPTIONS.ADD_VAT_DOCUMENT_TO_ENTITY
      },
      "2_179" : {
        field: 'taxReportingClassification',
        description: COMMON_DESCRIPTIONS.ADD_TAX_REPORTING_CLASSIFICATION
      },
      "2_180" : {
        field: 'taxReportingClassificationType',
        description: COMMON_DESCRIPTIONS.ADD_TAX_REPORTING_CLASSIFICATION_TYPE
      },
      "2_181" : {
        field: 'businessType',
        description: COMMON_DESCRIPTIONS.ADD_TAX_REPORTING_CLASSIFICATION_BUSINESS_TYPE
      },
      "2_182" : {
        field: 'mainSourceOfIncome',
        description: COMMON_DESCRIPTIONS.ADD_TAX_REPORTING_CLASSIFICATION_MAIN_SOURCE
      },
      "2_183" : {
        field: 'financialInstitutionNumber',
        description: COMMON_DESCRIPTIONS.ADD_TAX_REPORTING_CLASSIFICATION_FIN_INST_NUMBER
      },
    },
    BUSINESS_PROFILE : {
      "1_901" : {
        field: 'industry',
        description: COMMON_DESCRIPTIONS.UPDATE_INDUSTRY
      },
      "1_902" : {
        field: 'webAddress',
        description: COMMON_DESCRIPTIONS.UPDATE_WEB_ADDRESS
      },
      "1_905" : {
        field: 'webAddress',
        description: COMMON_DESCRIPTIONS.ADD_WEB_DATA_ADDRESS
      },
      "2_136" : {
        field: 'businessLine',
        description: COMMON_DESCRIPTIONS.ADD_BUSINESS_LINE
      },
      "2_159" : {
        field: 'sourceOfFunds',
        description: COMMON_DESCRIPTIONS.ADD_SOURCE_OF_FUNDS
      },
      "2_160" : {
        field: 'sourceOfFundsType',
        description: COMMON_DESCRIPTIONS.ADD_SOURCE_OF_FUNDS_TYPE
      },
      "2_164" : {
        field: 'adyenProcessedFunds',
        description: COMMON_DESCRIPTIONS.ADD_ADYEN_PROCESSED_FUNDS
      },
      "2_166" : {
        field: 'sourceOfFundsDescription',
        description: COMMON_DESCRIPTIONS.ADD_SOURCE_OF_FUNDS_DESCRIPTION
      },
      "2_176" : {
        field: 'industryCode',
        description: COMMON_DESCRIPTIONS.ADD_INDUSTRY_CODE
      },
      "2_177" : {
        field: 'channel',
        description: COMMON_DESCRIPTIONS.ADD_CHANNEL
      },
      "2_178" : {
        field: 'webAddress',
        description: COMMON_DESCRIPTIONS.ADD_WEB_ADDRESS_TO_BUSINESS_LINE
      },
    },
    DOCUMENT_UPLOAD : {
      "1_102" : {
        field: 'document',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_DOCUMENT
      },
      "1_301" : {
        field: 'idDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_ID_DOCUMENT
      },
      "1_302" : {
        field: 'idDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_ID_DOCUMENT
      },
      "1_303" : {
        field: 'idDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_ID_IMAGE
      },
      "1_304" : {
        field: 'proofOfResidency',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_RESIDENCY
      },
      "1_305" : {
        field: 'proofOfResidency',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_PROOF_OF_RESIDENCY
      },
      "1_306" : {
        field: 'proofOfResidency',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_RESIDENCY_IMAGE
      },
      "1_307" : {
        field: 'proofOfNationalId',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_NATIONAL_ID
      },
      "1_308" : {
        field: 'proofOfNationalId',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_PROOF_OF_NATIONAL_ID
      },
      "1_309" : {
        field: 'proofOfNationalId',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_NATIONAL_ID_IMAGE
      },
      "1_313" : {
        field: 'proofOfIndividualTaxId',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_INDIVIDUAL_TAX_ID_IMAGE
      },
      "1_314" : {
        field: 'proofOfIndividualTaxId',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_INDIVIDUAL_TAX_ID
      },
      "1_315" : {
        field: 'proofOfIndividualTaxId',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_PROOF_OF_INDIVIDUAL_TAX_ID
      },
      "1_501" : {
        field: 'registrationDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_REGISTRATION_DOCUMENT
      },
      "1_502" : {
        field: 'registrationDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_REGISTRATION_DOCUMENT
      },
      "1_503" : {
        field: 'proofOfOrganizationTaxInfo',
        description: 'Upload a proofOfOrganizationTaxInfo'
      },
      "1_504" : {
        field: 'proofOfOrganizationTaxInfo',
        description: 'Upload a different proofOfOrganizationTaxInfo'
      },
      "1_505" : {
        field: 'proofOfAddress',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_ADDRESS
      },
      "1_506" : {
        field: 'proofOfAddress',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_PROOF_OF_ADDRESS
      },
      "1_508" : {
        field: 'proofOfOwnership',
        description: 'Upload a proof of ownership'
      },
      "1_510" : {
        field: 'signatoryDocument',
        description: 'Make sure that the signing person has the rights to represent the organization or is a listed professional member (lawyer, accountant) in your country of business and upload the right document'
      },
      "1_511" : {
        field: 'affiliationDocument',
        description: 'Upload a document that proves the payout entity is 100% affiliated with the legal entity'
      },
      "1_512" : {
        field: 'vatDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_VAT_DOCUMENT
      },
      "1_513" : {
        field: 'vatDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_VAT_DOCUMENT
      },
      "1_601" : {
        field: 'constitutionalDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_CONSTITUTIONAL_DOCUMENT
      },
      "1_602" : {
        field: 'constitutionalDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_CONSTITUTIONAL_DOCUMENT
      },
      "1_703" : {
        field: 'bankStatement',
        description: COMMON_DESCRIPTIONS.UPLOAD_BANK_STATEMENT
      },
      "1_704" : {
        field: 'bankStatement',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_BANK_STATEMENT
      },
      "1_705" : {
        field: 'bankStatement',
        description: 'Upload an official bank statement'
      },
      "1_900" : {
        field: 'proofOfIndustry',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_INDUSTRY
      },
      "1_903" : {
        field: 'proofOfIndustry',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_PROOF_OF_INDUSTRY
      },
      "1_904" : {
        field: 'proofOfIndustry',
        description: COMMON_DESCRIPTIONS.UPLOAD_DIFFERENT_INDUSTRY_IMAGE
      },
      "2_126" : {
        field: 'document',
        description: COMMON_DESCRIPTIONS.UPLOAD_DOCUMENT
      },
      "2_127" : {
        field: 'driversLicense',
        description: 'Upload a drivers license'
      },
      "2_128" : {
        field: 'driversLicenseFront',
        description: 'Upload the front of a drivers license'
      },
      "2_129" : {
        field: 'driversLicenseBack',
        description: 'Upload the back of a drivers license'
      },
      "2_130" : {
        field: 'idCardFront',
        description: 'Upload the front of an ID card'
      },
      "2_131" : {
        field: 'idCardBack',
        description: 'Upload the back of an ID card'
      },
      "2_134" : {
        field: 'vatDocument',
        description: COMMON_DESCRIPTIONS.UPLOAD_VAT_DOCUMENT
      },
      "2_137" : {
        field: 'proofOfRegistration',
        description: 'Upload a proof of registration'
      },
      "2_157" : {
        field: 'passport',
        description: 'Upload a passport'
      },
      "2_184" : {
        field: 'constitutionalDocument',
        description: 'Add constitutional document for verification to legal entity'
      },
      "2_119" : {
        field: 'document',
        description: COMMON_DESCRIPTIONS.UPLOAD_ATTACHMENT_DOCUMENT
      },
      "2_188" : {
        field: 'proofOfOwnership',
        description: COMMON_DESCRIPTIONS.UPLOAD_PROOF_OF_OWNERSHIP
      },
    }
  }
}